module.exports = __webpack_public_path__ + "img/plus-icon-blue.22bc675f.svg";